// Languages.js

// List of common languages for translation pickers across the admin UI.
export const COMMON_LANGUAGE_CODES = Object.freeze([
  { code: 'zh', name: 'Chinese' },
  { code: 'en', name: 'English' },
  { code: 'es', name: 'Spanish' },
  { code: 'hi', name: 'Hindi' },
  { code: 'ar', name: 'Arabic' },
  { code: 'fr', name: 'French' },
  { code: 'pt', name: 'Portuguese' },
  { code: 'ru', name: 'Russian' },
  { code: 'id', name: 'Indonesian' },
  { code: 'de', name: 'German' },
]);

// Basic pluralization helper for English-style labels.
// Falls back to appending "s" for most words.
export const pluralizeTitle = (label) =>
  /(s|x|z|ch|sh)$/i.test(label) ? `${label}es` : `${label}s`;

// Returns a singular label for a node type definition.
export const getSingularLabel = (def, typeKey, language = 'en') => {
  if (def?.label) return def.label;
  return typeKey;
};

// Returns a plural label for a node type definition, falling back
// to the singular label when no plural is provided.
export const getPluralLabel = (def, typeKey, language = 'en') => {
  if (def?.labelPlural) return def.labelPlural;

  const singularLabel = getSingularLabel(def, typeKey, language);
  return singularLabel;
};

export default COMMON_LANGUAGE_CODES;
